export default {"src":"//tokenlon.im/_next/static/media/toggle-settings-to-set-pay-mode-en.4cbfee26.gif","height":250,"width":600};